export const CMSUserRole = {
  SUPER_ADMIN_DELETE: "SUPER_ADMIN_DELETE",
  SUPER_ADMIN: "SUPER_ADMIN",
  SUPPORT: "SUPPORT",
  ADMIN: "ADMIN",
};

export const CMSUserRoleOptions = [
  { id: CMSUserRole.SUPER_ADMIN_DELETE, label: "Super Admin Delete" },
  { id: CMSUserRole.SUPER_ADMIN, label: "Super Admin" },
  { id: CMSUserRole.ADMIN, label: "Admin" },
  { id: CMSUserRole.SUPPORT, label: "Support" },
];

export const CMSUserRoleLabels = {
  [CMSUserRole.SUPER_ADMIN_DELETE]: "Super Admin Delete",
  [CMSUserRole.SUPER_ADMIN]: "Super Admin",
  [CMSUserRole.SUPPORT]: "Support",
  [CMSUserRole.ADMIN]: "Admin",
};
